<app-loader></app-loader>
<div>
    <router-outlet #r="outlet"></router-outlet>
</div>
